import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { UserDataProvider } from "../../data-provider/user.dp";

let ChecklistComponent = {
    selector: "vcCheckList",
    templateUrl: "/angular/components/checklist/checklist.component.html",
    bindings: {},
    controller: class ChecklistController {
        private completed = false;
        private progress = 0;
        private message = null;
        private dismissSetup = true;
        private steps = [];
        private stepsCompleted = [];

        private $scope: any;
        private $cookies: any;
        private $window: any;
        private __env: any;
        private $mdDialog: any;
        private dialog: any;
        private campaignDataProvider: CampaignDataProvider;
        private userDataProvider: UserDataProvider;
        private activeCampaign: Campaign;

        public show_setup = true;

        constructor(
            $scope: any,
            $cookies: any,
            __env: any,
            $mdDialog: any,
            $window: any,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider
        ) {
            this.$scope = $scope;
            this.$cookies = $cookies;
            this.$mdDialog = $mdDialog;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.__env = __env;
            this.campaignDataProvider = CampaignDataProvider;
            this.userDataProvider = UserDataProvider;
            this.activeCampaign = CampaignDataProvider.activeCampaign;

            this.campaignDataProvider.setupSteps().then((data) => {
                if (data) {
                    this.completed = data.attributes.completed;
                    this.steps = this.$scope.steps = data.attributes.steps;
                    this.stepsCompleted = this.steps.filter((elem) => {
                        return elem.completed == 1;
                    });

                    if (this.completed && this.stepsCompleted.length === 0) {
                        this.dismissSetupCard();
                    } else {
                        this.dismissSetup = false;
                        this.progress = Math.round(
                            (this.stepsCompleted.length / this.steps.length) *
                                100
                        );
                        if (this.progress === 100) {
                            this.checklistCompleteMessage();
                        } else {
                            this.message = this.checklistMessage(this.progress);
                        }
                    }
                }
            });
        }

        openInviteDialog(step: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-user-invite",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    size: "large-plus",
                })
                .then(() => {
                    this.userDataProvider.resetUsersCount();
                    step.completed = 1;
                });
        }

        markStepCompleted(step: any, url?: string): void {
            this.campaignDataProvider
                .markSetupStepCompleted(step.id)
                .then((data) => {
                    step.completed = 1;
                });
        }

        dismissSetupCard() {
            this.dismissSetup = true;
            this.$cookies.put(
                "DISMISS_SETUP_" + this.activeCampaign.campaignid,
                this.dismissSetup,
                { domain: "." + this.__env.host, path: "/" }
            );
        }

        checklistCompleteMessage() {
            this.completed = true;
            this.campaignDataProvider.activeCampaign.setupComplete = true;
            this.message =
                "Nice work! You're all set to start managing your account.";
        }

        stepClicked(e, step) {
            if (step.id == 4) {
                this.openInviteDialog(step.id, e);
            } else if (step.id == 5) {
                this.markStepCompleted(step);
                this.$window.location = "/#/customize";
            } else if (step.id == 9) {
                e.preventDefault();
                this.$mdDialog.show({
                    templateUrl:
                        "/angular/components/campaign/apps-dialog.component.html",
                    targetEvent: e,
                    controller: ($scope, $mdDialog, __env: any) => {
                        $scope.__env = __env;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    },
                });
            }
        }

        startProductTour() {
            Intercom("startTour", 187681);
        }

        checklistMessage(progress) {
            if (progress <= 25) {
                return "Lets get started!";
            } else if (progress <= 50) {
                return "Great job!";
            } else if (progress <= 75) {
                return "Keep going!";
            }
            return "Almost there!";
        }
    },
};

angular
    .module("checklist", [])
    .component(ChecklistComponent.selector, ChecklistComponent);
